import types from "./mutation-types"

export default {
  setActive({ commit, state }, { id }) {
    for (let i = 0, l = state.operation.children[1].children.length; i < l; i++) {
      // if (i === id && !state.operation.children[1].children[i].isActive) {
      if (i === id) {
        if (!state.operation.children[1].children[i].isActive) {
          commit(types.ENABLE_OPERATION_ACTIVE, { i })
        }
        continue
      } else {
        commit(types.DISABLE_OPERATION_ACTIVE, { i })
      }
    }
  },
  unsetActive({ commit }, { id }) {
    commit(types.DISABLE_OPERATION_ACTIVE, { i: id })
  }
}
